import React from "react";
import {
  FileText,
  Truck,
  RefreshCcw,
  Landmark,
  UserCheck,
  AlertCircle,
} from "lucide-react";

function SatisSozlesmesi() {
  return (
    <div className="max-w-6xl mx-auto p-6 bg-gray-50 min-h-screen">
      <div className="text-center mb-12">
        <div className="inline-flex items-center justify-center gap-3 mb-6">
          <div className="bg-purple-500 p-3 rounded-full shadow-lg">
            <FileText className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-2xl md:text-3xl font-extrabold text-gray-900 uppercase">
            Mesafeli Satış Sözleşmesi
          </h1>
        </div>
        <p className="text-gray-600 max-w-2xl mx-auto">
          6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli
          Sözleşmeler Yönetmeliği'ne uygun olarak hazırlanmıştır.
        </p>
      </div>

      <div className="space-y-6">
        {/* Taraflar Kartı */}
        <div className="bg-white rounded-3xl p-8 shadow-md border border-gray-100">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="space-y-4">
              <h3 className="flex items-center gap-2 font-bold  uppercase tracking-wider">
                <Landmark className="w-5 h-5" /> Satıcı Bilgileri
              </h3>
              <div className="text-gray-700 space-y-1 bg-orange-50 p-4 rounded-2xl border border-orange-100">
                <p>
                  <strong>Ünvan:</strong> Ali Zilan (Classroom)
                </p>
                <p>
                  <strong>Adres:</strong> [Diyarbakır Sanal Ofis Adresiniz]
                </p>
                <p>
                  <strong>E-posta:</strong> classroom.destek@gmail.com
                </p>
              </div>
            </div>
            <div className="space-y-4">
              <h3 className="flex items-center gap-2 font-bold text-blue-600 uppercase tracking-wider">
                <UserCheck className="w-5 h-5" /> Alıcı Bilgileri
              </h3>
              <p className="text-gray-600 leading-relaxed bg-blue-50 p-4 rounded-2xl border border-blue-100">
                Platform üzerinden dijital eğitim içeriği satın alan ve ödeme
                formunda bilgileri yer alan kullanıcı "Alıcı" olarak kabul
                edilir.
              </p>
            </div>
          </div>
        </div>

        {/* Sözleşme Maddeleri Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-white p-6 rounded-3xl shadow-sm border border-gray-100">
            <h4 className="font-bold text-gray-900 mb-2 flex items-center gap-2">
              <Truck className="w-5 h-5 text-orange-500" /> Hizmetin İfası
            </h4>
            <p className="text-sm text-gray-600">
              Satın alınan dijital eğitim paketi, ödeme onaylandığı anda
              kullanıcının hesabına tanımlanır ve anında erişime açılır.
              Fiziksel bir kargo gönderimi söz konusu değildir.
            </p>
          </div>

          <div className="bg-red-50 p-6 rounded-3xl shadow-sm border border-red-100">
            <h4 className="font-bold text-red-900 mb-2 flex items-center gap-2">
              <RefreshCcw className="w-5 h-5" /> Cayma Hakkı İstisnası
            </h4>
            <p className="text-sm text-red-800 italic leading-relaxed">
              Yönetmelik gereği, dijital ortamda anında teslim edilen eğitim
              içerikleri (gayrimaddi mallar) için cayma hakkı kullanılamaz.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SatisSozlesmesi;
